import { render, staticRenderFns } from "./Evidence.vue?vue&type=template&id=928da4e6"
import script from "./Evidence.vue?vue&type=script&lang=ts"
export * from "./Evidence.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports